import { connect } from 'react-redux';
import { compose, hoistStatics, withProps } from 'recompose';
import { translate } from 'react-i18next';
import AllowGifEmoji from './AllowGifEmoji';
import ModuleService from '../../../services/module.service';

const mapStateToProps = state => ({
  installedModules: state.modules.modulesTypes,
});

const enhance = compose(
  connect(mapStateToProps),
  translate('portal'),
  withProps(props => ({
    allowed: props.installedModules.includes(ModuleService.TYPE_EMOJI_GIF),
  })),
);

export default hoistStatics(enhance)(AllowGifEmoji);



// WEBPACK FOOTER //
// ./src/components/modules/allowGifEmoji/index.js